<div class="container">
  <div class="left-section">
    <mat-form-field appearance="fill" class="import-form-field" style="background-color: #15151c;">
      <mat-select class="custom-backdrop-class import-panel " panelClass="import-select" [(ngModel)]="importType"
        (ngModelChange)="setImportType()">
        <mat-option *ngFor="let type of importTypes" [value]="type">{{type}}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill" class="import-form-field" style="background-color: #15151c;">
      <mat-select class="custom-backdrop-class import-panel " panelClass="import-select" [(ngModel)]="importYear"
        (ngModelChange)="setImportYear()">
        <mat-option *ngFor="let year of importYears" [value]="year">{{year}}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-radio-group class="import-quarters" aria-label="Select Quarter" [(ngModel)]="importQuarter"
      (ngModelChange)="setImportQuarter()">
      <mat-radio-button *ngFor="let quarter of importQuarters" [value]="quarter">{{quarter}}</mat-radio-button>
    </mat-radio-group>
  </div>

  <div class="right-section">
    <button id="import-button" (click)="openProImport()">Import PRO</button>
  </div>
</div>